"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _react = require("unistore/react");

var connect = function (mapStateToProps, actions) {
  return function (Child) {
    var connectedComponent = (0, _react.connect)(mapStateToProps, actions)(Child);
    connectedComponent[_utils.BRIGADE_CONNECT_KEY] = true;
    return connectedComponent;
  };
};

var _default = connect;
exports.default = _default;